import { ReplaySubject, Observable, Subject, BehaviorSubject, of, Subscription } from "rxjs";
import { PageEvent } from "@angular/material/paginator";
import { Sort } from "@angular/material/sort";
import { FilterDescriptor } from "../data-table.component";
import { ITableDataSource, Dictionary, ProviderOptions, PageDescriptor, SortDescriptor, TableDataSource } from "./model";
import { debounceTime } from "rxjs/operators";
import { filter } from "./filter.fun";



export class ClientDataSource<T = any> extends TableDataSource<T> {

    readonly allDataLoaded = true;

    readonly all$ = new BehaviorSubject<T[]>([]);
    get all(): T[] { return this.all$.value; }
    set all(value: T[]) { this.all$.next(value); this.refresh(); }


    private readonly _data$ = new BehaviorSubject<T[]>([]);
    readonly data$ = this._data$.asObservable();
    get data(): T[] { return this._data$.value; }


    public readonly termsFields: (keyof T)[] = [];
    constructor(data: T[] | Promise<T[]>) {
        super();
        this.loadData(data);
    }

    async loadData(data: T[] | Promise<T[]>) {
        this.all = await data; //this will call refresh
    }

    refresh(options?: { page?: PageDescriptor, sort?: SortDescriptor, filter?: FilterDescriptor }) {
        let data = filter(this.all, options?.filter, options?.sort, options?.page, this.termsFields);
        this._data$.next(data);
        return this.data$;
    }

    destroy?() { }


}

export function getByPath(obj: any, path: string) {
    const segments = path.split('.');
    let result = obj;
    while (segments.length) {
        const s = segments.shift();
        result = result[s];
    }
    return result;
}

export function compare(a, b): number {
    if (a?.localeCompare) return a.localeCompare(b);
    if (a > b) return 1;
    else if (a < b) return -1;
    else return 0;
}

